export { default as Img200 } from './processed/200/Pretty-Little-LIars-The-Perfectionists.jpg';
export { default as Img400 } from './processed/400/Pretty-Little-LIars-The-Perfectionists.jpg';
export { default as Imgthumb } from './processed/thumb/Pretty-Little-LIars-The-Perfectionists.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Pretty-Little-LIars-The-Perfectionists.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Pretty-Little-LIars-The-Perfectionists.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      162,
      60,
      64
    ],
    "_population": 25,
    "_hsl": [
      0.9934640522875817,
      0.45945945945945943,
      0.43529411764705883
    ]
  },
  "LightVibrant": {
    "_rgb": [
      237,
      218,
      172
    ],
    "_population": 228,
    "_hsl": [
      0.1179487179487179,
      0.6435643564356437,
      0.8019607843137255
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      97,
      35,
      44
    ],
    "_population": 11,
    "_hsl": [
      0.9758064516129031,
      0.46969696969696967,
      0.2588235294117647
    ]
  },
  "Muted": {
    "_rgb": [
      161,
      124,
      88
    ],
    "_population": 803,
    "_hsl": [
      0.08219178082191782,
      0.2931726907630522,
      0.48823529411764705
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      162,
      135
    ],
    "_population": 2335,
    "_hsl": [
      0.08490566037735843,
      0.2834224598930482,
      0.6333333333333333
    ]
  },
  "DarkMuted": {
    "_rgb": [
      98,
      48,
      51
    ],
    "_population": 46,
    "_hsl": [
      0.9899999999999999,
      0.3424657534246576,
      0.28627450980392155
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Pretty-Little-LIars-The-Perfectionists.js